export const MarketGroups = (market) => {
  const groupOne = ["GBR", "IRL"];
  const groupTwo = ["DEU", "AUT", "CHE"];
  const groupThree = ["ESP", "PRT"];

  switch (market) {
    case "GBR":
    case "IRL":
      return groupOne;
    case "DEU":
    case "AUT":
    case "CHE":
      return groupTwo;
    case "ESP":
    case "PRT":
      return groupThree;
    default:
      return [market];
  }
};
